// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateMexicanZipcode(zipcodeValue: string): ?UserInputValidationError {
  if (!zipcodeValue || zipcodeValue.trim() === '')
    return { id: 'empty' };
  else if (!/^\d{5}$/.test(zipcodeValue))
    return { id: 'invalid-pattern' };
}
